import React, { useEffect, useRef } from 'react';
import styles from './SearchCollapse.module.scss';
import { SearchTopic } from '../../SearchTopic/SearchTopic';
import { Topic } from '../../../Models';
import { Collapse } from '@material-ui/core';
import { useNavigate } from 'react-router-dom';
import { SFAutocompleteRefHandler } from 'sfui';

const TRANSITION_TIMEOUT = 480;

export interface SearchCollapseProps {
  show: boolean;
  topics: Topic[];
  onHide: () => void;
}

export const SearchCollapse = ({
  show,
  topics,
  onHide
}: SearchCollapseProps): React.ReactElement<SearchCollapseProps> => {
  const navigate = useNavigate();

  const onSelect = (value: string) => {
    onHide();
    navigate(`/topic/${value}`);
  };

  const ref = useRef<SFAutocompleteRefHandler>(null);

  useEffect(() => {
    if (show && ref.current) {
      setTimeout(() => {
        ref.current?.focus();
      }, TRANSITION_TIMEOUT);
    }
  }, [show]);

  return (
    <Collapse in={show} timeout={TRANSITION_TIMEOUT}>
      <div className={styles.searchCollapse}>
        <SearchTopic
          ref={ref}
          topics={topics}
          onSelect={onSelect}
          onBlur={onHide}
        />
      </div>
    </Collapse>
  );
};
